import script from "./PointOfSaleList.vue?vue&type=script&setup=true&lang=js"
export * from "./PointOfSaleList.vue?vue&type=script&setup=true&lang=js"

import "./PointOfSaleList.vue?vue&type=style&index=0&id=4866b5d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4866b5d8"]])

export default __exports__